module.exports = __webpack_public_path__ + "assets/images/epaybg.png?_9385cef5ec0b";